import { render } from "./SiteHorizontalNavigation.vue?vue&type=template&id=521d5e08&scoped=true&ts=true"
import script from "./SiteHorizontalNavigation.vue?vue&type=script&lang=ts"
export * from "./SiteHorizontalNavigation.vue?vue&type=script&lang=ts"

import "./SiteHorizontalNavigation.vue?vue&type=style&index=0&id=521d5e08&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\TTI.AVE.Web\\Vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-521d5e08"]])

export default __exports__